export const generateRandomId = () => Math.floor(Math.random() * 1000000);
